import * as React from 'react';
import { jsx, css, keyframes } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import type { AdvisorMessagePropsType } from '../..';

const { tablet, mobile } = mediaQueries();

type AdvisorChatBubblePropsType = Merge<AdvisorMessagePropsType & {
  message: React.ReactNode;
  isLoading: boolean;
}>;

export const AdvisorChatBubble = ({
  message,
  isLoading,
}: AdvisorChatBubblePropsType) => {
  return (
    <div
      css={css`
        font-size: 20px;
        width: fit-content;
        max-width: 530px;
        min-height: calc(1lh + 18px);
        padding: 9px 12px;
        background-color: #fff;
        border: 2px solid #041156;
        border-radius: 22px;
        position: relative;

        ${autoResponsiveClamp('font-size', 20, 15)}

        ${isLoading && css`
          display: flex;
          align-items: center;
        `}

        &::before,
        &::after {
          content: "";
          clip-path: polygon(100% 0, 0 50%, 100% 100%);
          position: absolute;
          transform: rotate(35deg);
          bottom: calc(100% - 12px);
          right: calc(100% - 6px);

          ${isLoading && css`
            display: none;
          `}
        }

        &::before {
          width: 15px;
          height: 14px;
          background-color: #041156;
        }

        &::after {
          width: 11px;
          height: 11px;
          background-color: #fff;
        }
      `}
    >
      {isLoading && (
        <div
          css={css`
            width: 90px;
          `}
        >
          <div
            css={css`
              padding-top: 1em;
              font-size: 10px;
              text-align: center;
              display: flex;
              justify-content: center;
              gap: 0 6px;

              & > div {
                width: 10px;
                height: 10px;
                background-color: #1d2932;
                border-radius: 50%;
                animation: ${keyframes`
                  0% {
                    transform: translateY(0) ;
                    opacity: 0.2;
                  }
                  50% {
                    transform: translateY(-10px) ;
                    opacity: 0.6;
                  }
                  100% {
                    transform: translateY(0) ;
                    opacity: 0.2;
                  }
                `} 0.8s infinite linear;
              }

              & > div:nth-of-type(2) {
                animation-delay: -0.6s;
              }

              & > div:nth-of-type(3) {
                animation-delay: -0.4s;
              }
            `}
          >
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      {!isLoading && (
        <p
          css={css`
            color: #000;
          `}
        >
          {message}
        </p>
      )}
    </div>
  );
};
